import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { T } from "services/lang/LanguageService";
import React from "react";
import { v4 as uuidv4 } from "uuid";
import { CellSubType } from "utils/enums";
import { Button } from "primereact/button";
import EditableCell from "./EditableCell";

export type Item = {
  id: string;
  value: string;
};

interface ChipsEditorProps {
  items: Item[];
  subType: CellSubType;
  onChange: (items: Item[]) => void;
}

const ChipsEditor = ({ items, subType, onChange }: ChipsEditorProps) => {
  const addNew = () => {
    onChange([...items, { id: uuidv4(), value: "" }]);
  };

  const valueBodyTemplate = (rowData: Item) => {
    return (
      <EditableCell
        value={rowData.value}
        subType={subType}
        onCommit={newVal => {
          const updated = items.map(item => (item.id === rowData.id ? { ...item, value: newVal } : item));
          onChange(updated);
        }}
      />
    );
  };

  const addButtonTemplate = () => {
    return (
      <Button
        label={T("action.add")}
        icon="pi pi-plus"
        className="component-editor-button icon-green"
        onClick={addNew}
      />
    );
  };

  const removeButtonTemplate = (rowData: Item) => {
    return (
      <Button
        icon="pi pi-times"
        className="p-button-text p-button-danger"
        onClick={() => onChange(items.filter(item => item.id !== rowData.id))}
      />
    );
  };

  return (
    <DataTable size="small" value={items} dataKey="id" reorderableRows onRowReorder={e => onChange(e.value)}>
      <Column rowReorder style={{ width: "10%" }} />
      <Column field="value" header={T("word.value")} style={{ width: "80%" }} body={valueBodyTemplate} />
      <Column
        field="remove"
        header={addButtonTemplate}
        style={{ width: "10%", textAlign: "end" }}
        body={removeButtonTemplate}
      />
    </DataTable>
  );
};

export default ChipsEditor;
